import { useAuth } from 'context/auth-context';
import useProfiles from 'hooks/profile/useProfiles';
import { UseQueryResult } from 'react-query';
import { ProfileRetrieve } from 'types';

function useOwnAthleteProfileAndSubAccountProfiles(gymId: string): UseQueryResult<{
  ownAthleteProfile: ProfileRetrieve | undefined;
  subAccountProfiles: ProfileRetrieve[];
}> {
  const { session } = useAuth();
  const { data: profilesData, ...rest } = useProfiles({
    user: session?.user.userId,
    role: 'athlete',
    athleteGym: gymId,
    includeLinked: true,
  });

  const ownAthleteProfile: ProfileRetrieve | undefined = profilesData?.pages
    .flatMap(page => page.data.results)
    .find(profile => profile.profileId === session?.profile?.profileId);

  const subAccountProfiles: ProfileRetrieve[] =
    profilesData?.pages
      .flatMap(page => page.data.results)
      .filter(profile => profile.isSubAccount)
      .filter(profile => profile.profileId !== ownAthleteProfile?.profileId) || [];

  return {
    ...rest,
    data: {
      ownAthleteProfile,
      subAccountProfiles,
    },
  } as UseQueryResult<{
    ownAthleteProfile: ProfileRetrieve | undefined;
    subAccountProfiles: ProfileRetrieve[];
  }>;
}

export default useOwnAthleteProfileAndSubAccountProfiles;
